
import React from "react";
import {Grid, Typography} from "@mui/material";

import Box from "@mui/material/Box";
import {useSelector} from "react-redux";
import ClinicalReportTable from "./ClinicalReportTable";
import PatientReportTable from "./PatientReportTable";
import MappedText from "../../study-page/create-study/analysis-page/components/clinical-info/mapText";
import { useParams } from "react-router-dom";
import useNavigate from "../../../components/tables/general-table/hooks/useNavigate";
import CaButton from "../../../gpap-lib/components/shared-components/CaButton";
import AddIcon from "@mui/icons-material/Add";



function Reports(props) {


    const participants = useSelector(state => state.generaltable.allDataApis.participants);
    const { id } = useParams();
    const navigate = useNavigate();


    return <div style={{width: "100%"}}>
        <Grid container direction={"row"}>
        
            <Grid item lg={12}>
                <Box display="flex" alignItems="center" justifyContent="space-between" >
                    {!window.config.werfen_endpoint && (
                        <Typography variant={"h5"}  style={{ fontWeight: "700" }}><MappedText text={"Clinical Reports"}/></Typography>
                    )}
                    {window.config.werfen_endpoint && (
                        <CaButton
                            variant="contained"
                            text="Create report"
                            startIcon={<AddIcon />}
                            onClick={() => navigate(`/dir_overview/${id}/new_clinical_report`)}
                            customStyles={{width:"140px"}}
                        />
                    )}
                </Box>   
            </Grid>
                {!window.config.werfen_endpoint && <ClinicalReportTable />}
            </Grid>
            
            {!window.config.werfen_endpoint && (
            <Grid item lg={12}>
                <Box display="flex" alignItems="center" justifyContent="flex-start" pt={4}>
                    <Typography variant={"h5"} style={{ marginRight: "455px", fontWeight: "700" }}><MappedText text={"Patient Reports"}/></Typography>
                </Box>
                <PatientReportTable />
            </Grid>
            )}
    </div>


}


export default Reports;